module.exports = __webpack_public_path__ + "static/media/pets.e5c18fcb.svg";